import React from "react";
import classes from "./SystemError.module.scss";
import PrimaryButtonLoader from "../button/PrimaryButton";
import Image from "../Image/Image";
import { useAppContent } from "../../../shared/AppContent";
import { useSelector } from "react-redux";

const SystemError = (props) => {
  const { photoKYCContent } = useAppContent();
  const currentAppState = useSelector((state) => state.AppState);
  //console.log("Props ", props)
  const { errorMsg, btnLabel, clickEvent, headerMsg } = props;
  //console.log(" errorMsg, btnLabel, clickEvent ", errorMsg, btnLabel, clickEvent)

  return (
    <div className={classes.Container}>
      <div className={classes.LabelContainer}>
        <div className={classes.ErrorImg}>
          <Image
            className={classes.ErrorLogo}
            filename="Group 1542"
            ext="png"
            renditions={["2x"]}
            alt=""
          />
        </div>
        <div className={classes.Heading}>
          {headerMsg ? headerMsg : photoKYCContent.blurry_photo.heading}
        </div>
        {/* <div className={classes.ErrorMsg}>Something went wrong here.</div> */}
        <div className={classes.ErrorMsg}>{errorMsg}</div>
        <div className={classes.ImgForMobile}>
          <Image
            className={`${classes.ErrorImgMobile} GlobalErrorImage`}
            filename="Group 1884"
            ext="png"
            renditions={["3x"]}
            alt=""
          />
        </div>
      </div>
      <div className={classes.PrimaryButton}>
        <PrimaryButtonLoader
          label={btnLabel}
          handleClick={clickEvent}
          className={classes.ErrorBtn}
          appState={currentAppState}
        // disabled={true}
        />
      </div>
    </div>
  );
};

export default SystemError;
